import React from 'react';
import { getEntryCount } from './runtimeConfigUtils';

const TAB_LABELS = { cors: 'CORS', frame: 'Frame', mime: 'MIME' };

const RuntimeConfigStatusBar = ({ configId, metadataItem, document, entryCount }) => {
  const entries = document
    ? getEntryCount(configId, document)
    : entryCount;

  return (
    <div className="runtime-config-status-bar" data-testid="runtime-config-status-bar">
      <span><strong>CONFIG</strong> {TAB_LABELS[configId] || configId}</span>
      <span><strong>VERSION</strong> v{metadataItem?.version ?? '—'}</span>
      <span>
        <strong>UPDATED</strong>{' '}
        {metadataItem?.updatedAt
          ? new Date(metadataItem.updatedAt).toLocaleString()
          : '—'}
      </span>
      <span><strong>AUTHOR</strong> {metadataItem?.author || '—'}</span>
      <span><strong>SOURCE</strong> {metadataItem?.source || '—'}</span>
      <span><strong>ENTRIES</strong> {entries ?? '—'}</span>
    </div>
  );
};

export default RuntimeConfigStatusBar;
